import Vue from 'vue'

export default {

  create (exportName, params) {
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/${exportName}`,
      { params: params }
    )
  }
}
